module.exports = __webpack_public_path__ + "static/media/sendBackwards.225d9029.svg";